/*
  Saved pieces (round 58), on every page once the Saved pieces page is published (snippets/vr-saved-url.liquid):
  - The list is kept by the visitor's own browser (localStorage "vr-saved": the pieces' handles, newest first, at most
    thirty). Nothing is sent anywhere until the visitor asks for their list by email on the Saved pieces page.
  - The gold diamond beside a piece's name (sections/main-product.liquid) keeps the piece or takes it out; a quiet note
    says so at the foot of the window, with the way to the list. GA4 hears of each piece kept (add_to_wishlist).
  - The header's diamond (beside the menu on a phone) and the phone menu's line are always there, with the number kept
    beside them once a piece is kept.
  - Another tab's change is shown here too. The Saved pieces page (assets/vr-saved-page.js) uses window.vrSaved.
*/
(function () {
  if (window.vrSaved) return;
  var KEY = 'vr-saved';
  var MAX = 30;
  var HANDLE = /^[a-z0-9][a-z0-9_-]{0,199}$/;
  var mem = null;
  var clean = function (list) {
    var seen = {};
    return (Array.isArray(list) ? list : []).filter(function (x) {
      if (!x || typeof x.h !== 'string' || !HANDLE.test(x.h) || seen[x.h]) return false;
      seen[x.h] = true;
      return true;
    }).slice(0, MAX);
  };
  var read = function () {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (raw != null) return clean(JSON.parse(raw));
    } catch (e) {}
    return clean(mem || []);
  };
  var write = function (list) {
    mem = list;
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  };
  var subs = [];
  var tell = function () { var l = read(); subs.forEach(function (fn) { try { fn(l); } catch (e) {} }); paint(); };

  var api = {
    list: function () { return read(); },
    has: function (h) { return read().some(function (x) { return x.h === h; }); },
    add: function (h) {
      if (!HANDLE.test(h)) return;
      var l = read().filter(function (x) { return x.h !== h; });
      l.unshift({ h: h, at: Date.now() });
      write(l.slice(0, MAX));
      tell();
    },
    remove: function (h) { write(read().filter(function (x) { return x.h !== h; })); tell(); },
    count: function () { return read().length; },
    on: function (fn) { subs.push(fn); }
  };
  window.vrSaved = api;

  /* ---- the header's diamond, the phone menu's line, every save mark on the page ---- */
  function paint() {
    var n = read().length;
    Array.prototype.forEach.call(document.querySelectorAll('[data-vr-saved-link]'), function (a) { a.classList.toggle('has-pieces', n > 0); });
    Array.prototype.forEach.call(document.querySelectorAll('[data-vr-saved-count]'), function (c) { c.textContent = n ? String(n) : ''; });
    Array.prototype.forEach.call(document.querySelectorAll('[data-vr-save]'), function (b) {
      var on = api.has(b.getAttribute('data-vr-save'));
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-saved', on);
      var w = b.querySelector('[data-vr-save-word]');
      if (w) w.textContent = on ? (b.getAttribute('data-word-on') || 'Saved') : (b.getAttribute('data-word-off') || 'Save');
    });
  }

  /* ---- the note at the foot of the window ---- */
  var note = null, noteTimer = 0;
  function say(text, url) {
    if (!note) {
      note = document.createElement('div');
      note.className = 'vr-save-note';
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      note.innerHTML = '<span class="vr-save-note__words"></span><a class="vr-save-note__link"></a>';
      document.body.appendChild(note);
    }
    note.querySelector('.vr-save-note__words').textContent = text;
    var a = note.querySelector('.vr-save-note__link');
    if (url) { a.href = url; a.textContent = 'See them'; a.hidden = false; } else { a.hidden = true; }
    clearTimeout(noteTimer);
    note.classList.remove('is-on');
    void note.offsetWidth;
    note.classList.add('is-on');
    noteTimer = setTimeout(function () { note.classList.remove('is-on'); }, 5200);
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-vr-save]') : null;
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-vr-save');
    var url = b.getAttribute('data-vr-saved-url') || '';
    if (api.has(h)) {
      api.remove(h);
      say('Taken out of your saved pieces.', url);
    } else {
      api.add(h);
      say('Kept in your saved pieces.', url);
      if (typeof window.gtag === 'function') {
        var name = b.getAttribute('data-vr-save-name') || h;
        var paise = Number(b.getAttribute('data-vr-save-price') || 0);
        var item = { item_id: h, item_name: name };
        var ev = { items: [item] };
        if (paise > 0) { item.price = paise / 100; ev.currency = 'INR'; ev.value = paise / 100; }
        try { window.gtag('event', 'add_to_wishlist', ev); } catch (x) {}
      }
    }
  });

  window.addEventListener('storage', function (e) { if (e.key === KEY || e.key === null) tell(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) paint(); });
  document.addEventListener('shopify:section:load', paint);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();
})();
